import { ProcessBuilderSearchableSelectionTable } from '@periscopes/general/process-builders';
import React from 'react';

export interface TagProcessBuildersTabProps {
	index: number;
	sonarObjectTagId: number;
}

export const TagProcessBuildersTab: React.FC<TagProcessBuildersTabProps> = ({ index, sonarObjectTagId }) => {
	const targetUri = `v2/tags/${sonarObjectTagId}/process-builders`;

	return <ProcessBuilderSearchableSelectionTable
		parentIndex={ index }
		uri={ targetUri } />;
};
